@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" [style]="nestedPadding$ | async">
        <sh-field-label
            [label]="profileField.DisplayLabel ? profileField.DisplayLabel : profileField.FieldDefinition.Label"
            [labelIcons]="labelIcons"
        ></sh-field-label>
        @if (index !== undefined) {
            <span>{{ index + 1 }}</span>
        }
    </dt>
    @if (locationFieldDefinition$ | async; as fieldDefinition) {
        @if (value$ | async; as value) {
            <dd class="sh-description-list__details">
                <span class="sh-icon-label">
                    <ng-container
                        *ngTemplateOutlet="
                            canSearchOnClick(fieldDefinition) ? searchableData : nonSearchableData;
                            context: { value: value, fieldDefinition: fieldDefinition }
                        "
                    >
                    </ng-container>
                </span>
                @if (record$ | async; as fragment) {
                    <button class="sh-link sh-icon-link openDialogButton" (click)="openLocationDialog(fragment, profileField.FieldDefinition)">
                        {{ "modules.general.form.location.show-map-location" | translate }}
                        <svg sh-icon class="sh-icon-link__icon" aria-hidden="true" [name]="'angle-right'"></svg>
                    </button>
                }
                @if (record$ | async; as record) {
                    <button
                        class="sh-link sh-icon-link openDialogButton"
                        [title]="'modules.general.form.location.show-all-subfields' | translate"
                        (click)="openSubFieldDialog($any(record), profileField, $any(value), fieldDefinition)"
                    >
                        {{ "modules.general.form.location.show-all-subfields" | translate }}
                        <svg sh-icon class="sh-icon-link__icon" aria-hidden="true" [name]="'angle-right'"></svg>
                    </button>
                }
            </dd>
        } @else {
            <dd class="sh-description-list__details">-</dd>
        }
    }
}

<ng-template #searchableData let-value="value" let-fieldDefinition="fieldDefinition">
    <span class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)">{{ value }}</span>
</ng-template>

<ng-template #nonSearchableData let-value="value">
    <span>{{ value }}</span>
</ng-template>
